import { type CheckBoxType, CheckBoxTypeSchema } from '@stratumn/studio-shared';
import { CheckSquare, type LucideIcon } from 'lucide-react';
import { parseWithZod } from '@/utils/parseZodSchema';

export const CheckBoxIcon: LucideIcon = CheckSquare;

export type CheckBoxTypeOption = {
  name: string;
  value: CheckBoxType;
  isDisabled?: boolean;
};

export const checkBoxTypeOptions: CheckBoxTypeOption[] = [
  {
    name: 'Checkbox',
    value: 'checkbox'
  },
  {
    name: 'Radio',
    value: 'radio'
  }
];

export const isCorrectCheckBoxType = (
  checkBoxType: string
): checkBoxType is CheckBoxType =>
  !!parseWithZod(CheckBoxTypeSchema, checkBoxType, 'CHECKBOX-1');
